import {combineEpics, ofType, PledgerEpic} from "@pledger/frontend-commons";
import {map} from "rxjs/operators";
import {NavigationMenuActions} from "./NavigationMenuActions";
import {AppActions} from "../../../ui/app/AppActions";

const menuItemSelectedEpic : PledgerEpic<any> = (actions$ ) =>
    actions$.pipe(
        ofType(NavigationMenuActions.NAVIGATION_MENU_SELECT_MENU_ITEM_ACTION.type),
        map((action) => {
            return action.payload.postAction;
        })
    );

const menuItemRetourB2CSelectedEpic : PledgerEpic<any> = (actions$ ) =>
    actions$.pipe(
        ofType(NavigationMenuActions.NAVIGATION_MENU_RETOUR_B2C_ITEM_ACTION.type),
        map((action) => {
            window.location.assign(process.env.REACT_APP_LANDINGPAGE_URL!);
            return AppActions.EMPTY_ACTION.build();
        })
    );


export const navigationMenuEpics = combineEpics(
    menuItemSelectedEpic,
    menuItemRetourB2CSelectedEpic

);